<template>
  <div class="range-slider-container">
    <b-field>
      <b-slider
        v-model="range"
        :custom-formatter="(val) => val + '%'"
        :tooltip="false"
        indicator
        rounded
        :max="150"
        lazy
      ></b-slider>
    </b-field>
  </div>
</template>
<script>
export default {
  name: 'InputRangeSlider',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      range: 0
    }
  },
  computed: {},
  methods: {},
  mounted () {
    this.range = this.value
  },
  watch: {
    range (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped lang="scss">
.range-slider-container {
  width: 200px;
}
</style>

<style lang="scss">
.range-slider-container {
  .b-slider .b-slider-track {
    height: 0.5rem;
  }
  .b-slider .b-slider-fill {
    width: 110%;
    background: #5666ff !important;
  }
  .b-slider .b-slider-thumb-wrapper.has-indicator .b-slider-thumb {
    padding: 12px 8px;
    font-size: 12px;
  }
  .b-slider {
    &.is-primary {
      .b-slider-track {
        border: none !important;
        background: #CBD5E1 !important;
      }
    }
  }
}
</style>
